export default __webpack_public_path__ + "static/redMullet-6c809812eb98f0c674e12fdf77916d83.jpeg";